import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { localeStore } from '~/mobx/localesStore';
import ModalHeader from '~/view/components/Controls/Modal/ModalHeader/ModalHeader';
import './style.scss';

export const PreviousOrderModalHeader: FC = memo(
  observer((): ReactElement => {
    const { loading, order } = previousOrderModalStore;

    const modalTitle = useMemo((): string => localeStore.t('Order') + (loading ? ' ' : ` #${order?.order_key || ''}`), [order, loading]);

    return (
      <ModalHeader title={modalTitle} wrapperClassName="previous-order-modal-product-header">
        {loading ? (
          <Skeleton width={200} height={21.6} />
        ) : (
          <p className="previous-order-modal-product-header__status">{localeStore.t(`${order?.order_status_code || ''}_status`)}</p>
        )}
      </ModalHeader>
    );
  })
);
